import css from "@css/modules/Resort.module.scss"
import { Resort } from "../../../types/Resort"
import { CSSProperties } from "react"
import { addCurrency } from "../../../utils"
import { ArrowDown1 } from "@css/icons/ArrowDown1"

interface Props {
    resort: Resort
}

export function Dues({ resort }: Props) {
    const { valueGrade } = resort
    const { minGreen, minRed, maxGreen, maxRed, currentValue } = valueGrade || {}
    const total = maxRed - minGreen
    const vars = {
        "--percentMin": (total ? ((maxGreen - minGreen) / total) * 100 : 0) + "%",
        "--percentMax": (total ? ((maxRed - minRed) / total) * 100 : 0) + "%",
        "--currentValue": (total ? ((minGreen - currentValue) / total) * 100 : 0) + "%"
    } as CSSProperties
    return (
        <div className={css.dues}>
            <div className={css.duesTitle}>Annual dues among the more affordable</div>
            <div className={css.line} style={vars}>
                <div className={css.min} data-value={addCurrency(maxGreen)} />
                <div className={css.value} />
                <ArrowDown1 className={css.arrow} />
                <div className={css.max} data-value={addCurrency(minRed)} />
            </div>
        </div>
    )
}
